(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3516],{

/***/ 11267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ApiParamKey; }
/* harmony export */ });
var ApiParamKey = {
  TYPE: 'type',
  PAGE_ID: 'page_id',
  PAGE_SLUG: 'page_slug',
  VALUE: 'value',
  GET_SECTION: 'get_section',
  IMAGE: 'image',
  POST: 'post',
  FILE: 'file',
  GALLERY: 'gallery',
  LIMIT: 'limit',
  VARIATION: 'variation',
  SPECIFICATION: 'specification',
  KEYWORD: 'keyword',
  PARENTPAGE: 'parent_page_id',
  DIVISION_ID: 'division_id',
  RADIUS: 'radius',
  KEY: 'key',
  CATEGORY_ID: 'category_id',
  DATE: 'date',
  FILTER: 'filter',
  TIME: 'timestamp',
  STARTDATE: 'start_date',
  ENDDATE: 'end_date'
};

/***/ }),

/***/ 93365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(27812);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50029);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2962);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(97346);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(82307);
/* harmony import */ var _components_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93264);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(87118);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36981);
/* harmony import */ var _components_animations_plus_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35752);
/* harmony import */ var _components_animations_plus_svg__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_components_animations_plus_svg__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92495);
/* harmony import */ var _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11267);
/* harmony import */ var _api_store__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38584);
/* harmony import */ var _api_redux_investor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16037);
/* harmony import */ var _utils_investmentCalculations__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82458);
/* harmony import */ var chart_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17757);
/* harmony import */ var chart_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(chart_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var simplebar_react_dist_simplebar_min_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(202);
/* harmony import */ var simplebar_react_dist_simplebar_min_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(simplebar_react_dist_simplebar_min_css__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(18698);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


// ===== IMPORTS =====
// Core React and Next.js imports



 // Component imports





 // API and Redux imports




 // Utility imports

 // Chart library import

 // CSS imports



/**
 * Investment Calculator Component
 * Allows users to calculate potential returns on stock investments
 * Supports multiple stocks selection and custom time periods
 */




var InvestorCalculator = function InvestorCalculator() {
  var _getPost$posts, _getPost$posts$data;

  // ===== REDUX STATE =====
  var getPost = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function (state) {
    return state.investorReducer;
  });
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)(); // Extract page data from Redux store

  var page_data = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts = getPost.posts) === null || _getPost$posts === void 0 ? void 0 : (_getPost$posts$data = _getPost$posts.data) === null || _getPost$posts$data === void 0 ? void 0 : _getPost$posts$data.page_data; // ===== COMPONENT STATE =====
  // UI State

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true),
      winWidth = _useState[0],
      setWinWidth = _useState[1]; // Track if window width > 767px


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      can = _useState2[0],
      setCan = _useState2[1]; // Controls chart visibility
  // Form State


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      selectedOptions = _useState3[0],
      setSelectedOptions = _useState3[1]; // Selected stocks


  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      selectedAPIData = _useState4[0],
      setSelectedAPIData = _useState4[1]; // Selected stocks


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      selectedOptionsYear = _useState5[0],
      setSelectedOptionsYear = _useState5[1]; // Selected investment period


  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      payment = _useState6[0],
      setPayment = _useState6[1]; // Starting amount (unused but kept for compatibility)


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0),
      principle = _useState7[0],
      setPriciple = _useState7[1]; // Principal amount for calculations


  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      startDate = _useState8[0],
      setStartDate = _useState8[1]; // Start date for calculations
  // Modal State


  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      showOthersModal = _useState9[0],
      setShowOthersModal = _useState9[1]; // Custom year modal visibility


  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      customYear = _useState10[0],
      setCustomYear = _useState10[1]; // Custom year input value
  // Data State


  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      dropdownOptions = _useState11[0],
      setDropdownOptions = _useState11[1]; // Available stocks from API


  var _useState12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      dataOption = _useState12[0],
      setDataOption = _useState12[1]; // Chart data
  // Error State


  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      modalYearError = _useState13[0],
      setModalYearError = _useState13[1];

  var _useState14 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      paymentError = _useState14[0],
      setPaymentError = _useState14[1];

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      yearError = _useState15[0],
      setYearError = _useState15[1]; // Calculation Results State


  var _useState16 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0),
      calculatedFinalValue = _useState16[0],
      setCalculatedFinalValue = _useState16[1];

  var _useState17 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0),
      calculatedTotalReturn = _useState17[0],
      setCalculatedTotalReturn = _useState17[1];

  var _useState18 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0),
      calculatedCAGR = _useState18[0],
      setCalculatedCAGR = _useState18[1];

  var _useState19 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      lastSelectedStocks = _useState19[0],
      setLastSelectedStocks = _useState19[1];

  var _useState20 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      lastSelectedYears = _useState20[0],
      setLastSelectedYears = _useState20[1];

  var _useState21 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      usedFallbackCalculation = _useState21[0],
      setUsedFallbackCalculation = _useState21[1]; // ===== EFFECTS =====

  /**
   * Initialize component - set up window resize listener and fetch dropdown options
   * To modify: Change breakpoint (767) for mobile/desktop detection
   * To modify: Update API endpoint for stock options
   */


  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    // Set initial window width state
    var updateWindowWidth = function updateWindowWidth() {
      setWinWidth(window.innerWidth > 767);
    };

    updateWindowWidth();
    window.addEventListener("resize", updateWindowWidth); // Fetch available stocks from API

    fetchDropdownOptions(); // Cleanup event listener

    return function () {
      return window.removeEventListener("resize", updateWindowWidth);
    };
  }, []); // ===== API FUNCTIONS =====

  /**
   * Fetches available stock options from API
   * To modify: Change API endpoint or add additional data processing
   * To modify: Update fallback stock list with current available stocks
   */

  var fetchDropdownOptions = /*#__PURE__*/function () {
    var _ref = (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
      var response, data, options;
      return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch('https://cms.shantasecurities.com/api/get-req-data/investor-column');

            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.json();

            case 6:
              data = _context.sent;

              if (data.status === 200 && data.columns) {
                options = data.columns.map(function (column) {
                  return {
                    value: column,
                    label: column
                  };
                });
                setDropdownOptions(options);
              }

              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.error('Failed to fetch dropdown options:', _context.t0); // Fallback to hardcoded options if API fails
              // TO MODIFY: Update this list with current available stocks

              setDropdownOptions([{
                value: 'BRACBANK',
                label: 'BRAC BANK'
              }, {
                value: 'CITYBANK',
                label: 'CITY BANK'
              }, {
                value: 'SQURPHARMA',
                label: 'SQUR PHARMA'
              }, {
                value: 'RENATA',
                label: 'RENATA'
              }, {
                value: 'BXPHARMA',
                label: 'BX PHARMA'
              }, {
                value: 'MARICO',
                label: 'MARICO'
              }, {
                value: 'RECKITTBEN',
                label: 'RECKITTBEN'
              }, {
                value: 'OLYMPIC',
                label: 'OLYMPIC'
              }, {
                value: 'BATBC',
                label: 'BATBC'
              }, {
                value: 'LHBL',
                label: 'LHBL'
              }, {
                value: 'UNILEVERCL',
                label: 'UNILEVERCL'
              }, {
                value: 'HEIDELBCEM',
                label: 'HEIDELBCEM'
              }, {
                value: 'LINDEBD',
                label: 'LINDEBD'
              }, {
                value: 'BERGERPBL',
                label: 'BERGERPBL'
              }, {
                value: 'GP',
                label: 'GP'
              }, {
                value: 'UPGDCL',
                label: 'UPGDCL'
              }]);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function fetchDropdownOptions() {
      return _ref.apply(this, arguments);
    };
  }(); // ===== UTILITY FUNCTIONS =====

  /**
   * Formats date to YYYY-MM-DD format
   * To modify: Change date format as needed
   */


  var formatDate = function formatDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
  }; // ===== EVENT HANDLERS =====

  /**
   * Handles payment input changes and clears errors
   * To modify: Add input validation or formatting
   */


  var handlePayment = function handlePayment(selected) {
    setPayment(selected);
    clearPaymentError();
  };
  /**
   * Handles stock selection changes
   * To modify: Add validation for maximum selection limit
   */


  var handleSelection = function handleSelection(selected) {
    setSelectedOptions(selected);
  }; // UseEffect no longer needed for modal year handling
  // useEffect(() => {
  //     if (!showOthersModal && shouldSubmitAfterYearSet && selectedOptionsYear) {
  //         const syntheticEvent = { preventDefault: () => {} };
  //         handleSubmit(syntheticEvent);
  //         setShouldSubmitAfterYearSet(false);
  //     }
  // }, [showOthersModal, shouldSubmitAfterYearSet, selectedOptionsYear]);


  var handleSelectionYear = function handleSelectionYear(selected) {
    if ((selected === null || selected === void 0 ? void 0 : selected.value) === 'others') {
      var _document$querySelect;

      // Check if starting amount is filled before opening modal
      var paymentValue = (_document$querySelect = document.querySelector('input[name="payment"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value;

      if (!paymentValue || paymentValue.trim() === '') {
        setPaymentError('Please enter starting amount first.');
        return;
      }

      setShowOthersModal(true);
    } else {
      setSelectedOptionsYear(selected === null || selected === void 0 ? void 0 : selected.value);
      clearYearError();
    }
  };

  var handleOthersYearSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
      var yearNumber, syntheticEvent;
      return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              yearNumber = parseInt(customYear);

              if (yearNumber >= 1 && yearNumber <= 15) {
                setShowOthersModal(false); // Close modal immediately

                setCustomYear('');
                clearYearError(); // Directly call handleSubmit with the custom year value

                syntheticEvent = {
                  preventDefault: function preventDefault() {}
                };
                handleSubmit(syntheticEvent, customYear);
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleOthersYearSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Handles closing the custom year modal
   * To modify: Add additional cleanup logic if needed
   */


  var handleOthersModalClose = function handleOthersModalClose() {
    setShowOthersModal(false);
    setCustomYear('');
    setModalYearError('');
  }; // ===== ERROR HANDLING FUNCTIONS =====

  /**
   * Clears payment error messages from both state and DOM
   * To modify: Add additional error clearing logic
   */


  var clearPaymentError = function clearPaymentError() {
    if (typeof document !== 'undefined') {
      var errorElement = document.getElementById('paymentError');
      if (errorElement) errorElement.textContent = '';
    }

    setPaymentError('');
  };
  /**
   * Clears year selection error messages from both state and DOM
   * To modify: Add additional error clearing logic
   */


  var clearYearError = function clearYearError() {
    if (typeof document !== 'undefined') {
      var errorElement = document.getElementById('yearError');
      if (errorElement) errorElement.textContent = '';
    }

    setYearError('');
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(e) {
      var _document$querySelect2;

      var overrideYear,
          paymentValue,
          selectedOptionsArray,
          selectedStocks,
          selectedStocksYear,
          selectedDate,
          principleAmount,
          updatedDataOption,
          yearParam,
          final_value,
          total_return,
          cagr,
          useClientSideCalculation,
          _apiData$csgrFinal,
          apiUrl,
          response,
          apiData,
          _apiData$totalreturn,
          _apiData$totalreturn_,
          _apiData$totalreturn_2,
          dailyData,
          currentPortfolioValue,
          _startDate,
          endDate,
          portfolioResults,
          currentYear,
          currentMonth,
          startYearClient,
          last,
          resultElement,
          _args3 = arguments;

      return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              overrideYear = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
              e.preventDefault(); // Reset UI & state

              clearPaymentError();
              clearYearError();
              document.getElementById('paymentError').textContent = '';
              document.getElementById('yearError').textContent = '';
              setDataOption([]);
              paymentValue = (_document$querySelect2 = document.querySelector('input[name="payment"]')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value;
              selectedOptionsArray = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
              selectedStocks = selectedOptionsArray.map(function (option) {
                return option.value;
              });
              selectedStocksYear = overrideYear || selectedOptionsYear;
              selectedDate = startDate ? formatDate(startDate) : formatDate(new Date()); // Input validation

              if (paymentValue) {
                _context3.next = 15;
                break;
              }

              setPaymentError('Please enter starting amount.');
              return _context3.abrupt("return");

            case 15:
              if (!(!selectedStocksYear || typeof selectedStocksYear === 'string' && selectedStocksYear.trim() === '' || Array.isArray(selectedStocksYear) && selectedStocksYear.length < 1)) {
                _context3.next = 18;
                break;
              }

              setYearError('Please select a year.');
              return _context3.abrupt("return");

            case 18:
              _context3.prev = 18;
              setPriciple(paymentValue);
              principleAmount = parseFloat(paymentValue);
              updatedDataOption = [];
              yearParam = Number(selectedStocksYear);
              final_value = 0;
              total_return = 0;
              cagr = 0;
              useClientSideCalculation = false;
              _context3.prev = 27;
              // Use the new API endpoint to get investor data with all calculations
              apiUrl = "https://cms.shantasecurities.com/api/get-req-data/investor-data?stock=".concat(selectedStocks.join(','), "&year=").concat(yearParam, "&payment=").concat(paymentValue);
              _context3.next = 31;
              return fetch(apiUrl);

            case 31:
              response = _context3.sent;
              _context3.next = 34;
              return response.json();

            case 34:
              apiData = _context3.sent;
              setCalculatedCAGR(apiData === null || apiData === void 0 ? void 0 : (_apiData$csgrFinal = apiData.csgrFinal) === null || _apiData$csgrFinal === void 0 ? void 0 : _apiData$csgrFinal.csgr_percentage);
              console.log('API Response:', apiData);
              setSelectedAPIData(apiData); // Check if we have valid API data

              if (!(apiData && apiData.summary)) {
                _context3.next = 46;
                break;
              }

              // Use the pre-calculated summary values from API
              final_value = parseFloat(apiData === null || apiData === void 0 ? void 0 : (_apiData$totalreturn = apiData.totalreturn) === null || _apiData$totalreturn === void 0 ? void 0 : _apiData$totalreturn[0].final_value) || 0;
              total_return = parseFloat(apiData === null || apiData === void 0 ? void 0 : (_apiData$totalreturn_ = apiData.totalreturn_with_dividend) === null || _apiData$totalreturn_ === void 0 ? void 0 : (_apiData$totalreturn_2 = _apiData$totalreturn_[0]) === null || _apiData$totalreturn_2 === void 0 ? void 0 : _apiData$totalreturn_2.total_return_percentage) || 0;
              cagr = parseFloat(apiData.summary.cagr_with_dividends_pct) || 0;
              console.log(apiData.data, 'chart data'); // Process the daily data for chart visualization

              if (apiData.portfolioValue && Array.isArray(apiData.portfolioValue) && apiData.portfolioValue.length > 0) {
                dailyData = apiData.portfolioValue;
                currentPortfolioValue = principleAmount; // Create chart data points from daily returns

                dailyData.forEach(function (dayData) {
                  var date = new Date(dayData.date);
                  var dailyMultiplier = 1; //
                  // console.log(dayData, 'daily data')
                  // // Calculate combined daily multiplier for selected stocks
                  // selectedStocks.forEach((stock) => {
                  //     if (dayData[stock] !== null && dayData[stock] !== undefined) {
                  //         const dailyReturn = parseFloat(dayData[stock]);
                  //         dailyMultiplier *= (1 + dailyReturn);
                  //     }
                  // });
                  //
                  // // Apply to portfolio value
                  // currentPortfolioValue *= dailyMultiplier;

                  updatedDataOption.push({
                    x: date,
                    y: parseFloat(dayData === null || dayData === void 0 ? void 0 : dayData.value_rounded.toFixed(2))
                  });
                });
              } else {
                // Create simple chart data if no daily data available
                _startDate = new Date();

                _startDate.setFullYear(_startDate.getFullYear() - yearParam);

                endDate = new Date();
                updatedDataOption.push({
                  x: _startDate,
                  y: principleAmount
                }, {
                  x: endDate,
                  y: final_value
                });
              }

              _context3.next = 47;
              break;

            case 46:
              throw new Error('Invalid API response structure - missing summary data');

            case 47:
              _context3.next = 63;
              break;

            case 49:
              _context3.prev = 49;
              _context3.t0 = _context3["catch"](27);
              console.error('API failed, falling back to client-side calculation:', _context3.t0);
              useClientSideCalculation = true; // Fallback to client-side calculation

              portfolioResults = (0,_utils_investmentCalculations__WEBPACK_IMPORTED_MODULE_12__/* .calculatePortfolioValue */ .Us)(principleAmount, selectedStocks, yearParam);
              final_value = portfolioResults.finalValue;
              total_return = portfolioResults.totalReturn;
              cagr = portfolioResults.cagr;
              currentYear = new Date().getFullYear();
              currentMonth = new Date().getMonth();
              startYearClient = currentYear - yearParam + 1;
              portfolioResults.yearlyData.forEach(function (yearData, index) {
                var nextYearData = portfolioResults.yearlyData[index + 1];
                if (!nextYearData) return;
                var startValue = yearData.value;
                var endValue = nextYearData.value;
                var startYear = startYearClient + yearData.year - 1;
                var startDate = new Date(startYear, 0, 1);
                var endDate = new Date(startYear + 1, 0, 1);
                var totalDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));

                for (var d = 0; d < totalDays; d++) {
                  var date = new Date(startDate);
                  date.setDate(date.getDate() + d);
                  var interpolatedValue = startValue + (endValue - startValue) * d / totalDays;
                  updatedDataOption.push({
                    x: date,
                    y: parseFloat(interpolatedValue.toFixed(2))
                  });
                }
              });
              last = portfolioResults.yearlyData.at(-1);

              if ((last === null || last === void 0 ? void 0 : last.value) !== undefined) {
                updatedDataOption.push({
                  x: new Date(currentYear, currentMonth, 1),
                  y: parseFloat(last.value.toFixed(2))
                });
              }

            case 63:
              // Sort chart data by date
              updatedDataOption.sort(function (a, b) {
                return new Date(a.x) - new Date(b.x);
              });
              setDataOption(updatedDataOption);
              console.log('Final Value:', final_value);
              console.log('Total Return:', total_return + '%');
              console.log('CAGR:', cagr + '%');
              setCalculatedFinalValue(final_value);
              setCalculatedTotalReturn(total_return);
              setCalculatedCAGR(cagr);
              setLastSelectedStocks(selectedOptionsArray);
              setLastSelectedYears(selectedStocksYear);
              setUsedFallbackCalculation(useClientSideCalculation);
              setCan(true);
              _context3.next = 82;
              break;

            case 77:
              _context3.prev = 77;
              _context3.t1 = _context3["catch"](18);
              console.error('Calculation error:', _context3.t1);
              resultElement = document.querySelector('.result');

              if (resultElement) {
                resultElement.innerHTML = "\n                <div class=\"result-wrp error\">\n                    <p>Unable to calculate investment returns. Please try again.</p>\n                </div>\n            ";
              }

            case 82:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[18, 77], [27, 49]]);
    }));

    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var uniqueDataOption = (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(new Map(dataOption.map(function (item) {
    return [item.x, item];
  })).values());

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    // Check if dataOption exists and has a length property
    if (dataOption && dataOption.length > 0) {
      var _formatDate = function _formatDate(dateString) {
        var date = new Date(dateString);
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var month = monthNames[date.getMonth()];
        var year = date.getFullYear();
        return "".concat(month, " ").concat(year);
      }; // Sort dataOption by date


      var sortedData = dataOption.sort(function (a, b) {
        return new Date(a.x) - new Date(b.x);
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          y: typeof item.y === 'string' ? parseFloat(item.y.replace(/,/g, '')) : item.y
        });
      }); // Calculate intervals based on the month of each data point

      var intervals = [];

      for (var i = 0; i < sortedData.length - 1; i++) {
        var currentDate = new Date(sortedData[i].x);
        var nextDate = new Date(sortedData[i + 1].x);
        var monthDiff = (nextDate.getFullYear() - currentDate.getFullYear()) * 12 + nextDate.getMonth() - currentDate.getMonth();

        if (monthDiff >= 6) {
          intervals.push(_formatDate(sortedData[i].x));
        }
      } // Filter original dataset and create a new dataset with modified x values


      var newData = sortedData.map(function (item) {
        return {
          x: _formatDate(item.x),
          y: Number(item.y)
        };
      });

      (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4() {
        var data;
        return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = newData;
                new (chart_js__WEBPACK_IMPORTED_MODULE_13___default())(document.getElementById('line-chart'), {
                  type: 'bar',
                  responsive: true,
                  data: {
                    labels: data.map(function (row) {
                      return row.x;
                    }),
                    datasets: [{
                      backgroundColor: "#978C21",
                      borderColor: "#3182ce",
                      label: 'Investment Calculator',
                      data: data.map(function (row) {
                        return row.y;
                      })
                    }]
                  },
                  options: {
                    maintainAspectRatio: false,
                    scales: {
                      yAxes: [{
                        ticks: {
                          fontSize: 12 // Adjust the font size here

                        }
                      }],
                      xAxes: [{
                        ticks: {
                          fontSize: 14 // Adjust the font size here

                        }
                      }]
                    },
                    tooltips: {
                      callbacks: {
                        label: function label(tooltipItem, data) {
                          return 'Portfolio Price: ' + tooltipItem.yLabel;
                        }
                      }
                    },
                    legend: {
                      labels: {
                        fontSize: 24,
                        // Adjust the font size for the legend label
                        fontColor: '#3c3c3b',
                        // Change the font color
                        fontStyle: 'bold' // Change the font weight

                      }
                    }
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }, [dataOption]);
  var DropdownOptionYear = [{
    value: '2',
    label: '2 years'
  }, {
    value: '5',
    label: '5 years'
  }, {
    value: '10',
    label: '10 years'
  }, {
    value: '15',
    label: '15 years'
  }, {
    value: 'others',
    label: 'Others (Write any integer between 1-15)'
  }];

  var CustomMultiValue = function CustomMultiValue(_ref5) {
    var data = _ref5.data;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
        children: data.label
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)((_components_animations_plus_svg__WEBPACK_IMPORTED_MODULE_7___default()), {
        style: {
          marginLeft: '5px',
          verticalAlign: 'middle',
          marginRight: '5px',
          top: '-2px',
          position: 'relative'
        }
      })]
    });
  };

  var CustomMultiValueLabel = function CustomMultiValueLabel(_ref6) {
    var data = _ref6.data;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
        children: data.label
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)((_components_animations_plus_svg__WEBPACK_IMPORTED_MODULE_7___default()), {
        style: {
          marginLeft: '5px',
          verticalAlign: 'middle',
          marginRight: '5px',
          top: '-2px',
          position: 'relative'
        }
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(StyledComponent, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_4__/* .NextSeo */ .PB, {
      title: "".concat(page_data !== null && page_data !== void 0 && page_data.title ? (page_data === null || page_data === void 0 ? void 0 : page_data.title) + ' | Shanta Securities Limited' : ''),
      description: page_data === null || page_data === void 0 ? void 0 : page_data.meta_description,
      openGraph: {
        title: page_data === null || page_data === void 0 ? void 0 : page_data.og_title,
        description: page_data === null || page_data === void 0 ? void 0 : page_data.og_description
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
      className: "investor_calculator pb-200 pt-200",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
            md: 12,
            className: "modal-data__content",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
              "class": 'desktop-view',
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                className: 'form',
                md: 6,
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_Title__WEBPACK_IMPORTED_MODULE_5__["default"], {
                  margin: '0 0 30px 0',
                  text: 'Investment Calculator'
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                  className: "form-wrapper-all",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    onSubmit: handleSubmit,
                    method: "post",
                    enctype: "multipart/form-data",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Group */ .Z.Group, {
                        className: "col-md-12 pb-30 form-wrapper",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Control */ .Z.Control, {
                          className: 'form-control-lg',
                          type: "number",
                          name: "payment",
                          placeholder: "Starting Amount",
                          required: true,
                          onChange: handlePayment
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                          id: "paymentError",
                          className: "calculator-error-message",
                          children: paymentError
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Group */ .Z.Group, {
                        className: "col-md-12 pb-30 form-wrapper",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP, {
                          isMulti: true,
                          placeholder: 'Stock',
                          onChange: handleSelection // replace with your selection handler function
                          ,
                          styles: {
                            dropdownIndicator: function dropdownIndicator(provided, state) {
                              return _objectSpread(_objectSpread({}, provided), {}, {
                                transform: state.selectProps.menuIsOpen && "rotate(180deg)"
                              });
                            }
                          },
                          classNamePrefix: 'react-select',
                          className: 'form-select',
                          isSearchable: true,
                          isOptionDisabled: function isOptionDisabled() {
                            return selectedOptions.length >= 5;
                          },
                          options: dropdownOptions // replace with your dropdown options
                          ,
                          theme: function theme(_theme) {
                            return _objectSpread(_objectSpread({}, _theme), {}, {
                              borderRadius: 0,
                              colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
                                primary25: '#e9e9e9',
                                primary: 'black'
                              })
                            });
                          }
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("p", {
                          className: 'hints',
                          children: "Select up to 5 Stocks"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Group */ .Z.Group, {
                        className: "col-md-12 pb-30 form-wrapper last",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP, {
                          placeholder: 'Year',
                          name: "year",
                          onChange: handleSelectionYear // replace with your selection handler function
                          ,
                          styles: {
                            dropdownIndicator: function dropdownIndicator(provided, state) {
                              return _objectSpread(_objectSpread({}, provided), {}, {
                                transform: state.selectProps.menuIsOpen && "rotate(180deg)"
                              });
                            }
                          },
                          classNamePrefix: 'react-select',
                          className: 'form-select',
                          options: DropdownOptionYear // replace with your dropdown options
                          ,
                          theme: function theme(_theme2) {
                            return _objectSpread(_objectSpread({}, _theme2), {}, {
                              borderRadius: 0,
                              colors: _objectSpread(_objectSpread({}, _theme2.colors), {}, {
                                primary25: '#e9e9e9',
                                primary: 'black'
                              })
                            });
                          }
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                          id: "yearError",
                          className: "calculator-error-message",
                          children: yearError
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                        className: "clear"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Group */ .Z.Group, {
                        className: "col-xl-6 widthHalf",
                        onClick: handleSubmit,
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                          margin: '0 40px 0 0',
                          padding: '0',
                          hoverColor: '#3C3C3B',
                          hoverBackground: '#3C3C3B',
                          width: 'auto',
                          text: 'Calculate',
                          classname: 'col-md-6'
                        })
                      })]
                    })
                  })
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                md: {
                  span: 5,
                  offset: 1
                },
                id: 'result',
                className: 'result',
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                  className: "result-wrp",
                  children: calculatedFinalValue !== null && calculatedFinalValue !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("p", {
                      children: ["If you invested equally in ", lastSelectedStocks.map(function (stock) {
                        return stock.label;
                      }).join(', '), ", ", lastSelectedYears, " years ago, today you would have had"]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("h3", {
                      children: (0,_utils_investmentCalculations__WEBPACK_IMPORTED_MODULE_12__/* .formatCurrency */ .xG)(calculatedFinalValue)
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("p", {
                      children: "Total Return"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("h3", {
                      children: (0,_utils_investmentCalculations__WEBPACK_IMPORTED_MODULE_12__/* .formatPercentage */ .rl)(calculatedTotalReturn)
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("p", {
                      children: "CAGR"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("h3", {
                      children: (0,_utils_investmentCalculations__WEBPACK_IMPORTED_MODULE_12__/* .formatPercentage */ .rl)(calculatedCAGR)
                    }), usedFallbackCalculation && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("p", {
                      className: "calculation-note",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("small", {
                        children: "* Calculated using estimated returns"
                      })
                    })]
                  })
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
              className: 'desktop-view-blog',
              children: [(dataOption === null || dataOption === void 0 ? void 0 : dataOption[0]) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                md: 12,
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                  className: "relative chart-container h-350-px",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("canvas", {
                    id: "line-chart"
                  })
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                className: 'invest-content',
                md: 12,
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_Title__WEBPACK_IMPORTED_MODULE_5__["default"], {
                  noanim: true,
                  margin: '0 0 30px 0',
                  text: 'Using Investment Calculator'
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("li", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
                      children: "Enter the amount"
                    }), " you wish you had invested a certain number of years ago."]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("li", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
                      children: "Select up to five different types"
                    }), " of stocks for your investment during that period. The specified investment will be evenly distributed among the chosen stocks. You could even opt to select just one stock as well."]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("li", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
                      children: "Choose the duration"
                    }), " you would have preferred to maintain your investment. In the case of stock investments, it is typically recommended to remain invested for a minimum of five years."]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("li", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
                      children: "Click the \"Calculate\""
                    }), " button to estimate the potential income you could have gained from those investments if made in the past, considering the current date as the ending point."]
                  })]
                })]
              })]
            })]
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
      show: showOthersModal,
      onHide: handleOthersModalClose,
      centered: true,
      size: "lg",
      dialogClassName: "custom-modal-width",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Header */ .Z.Header, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Title */ .Z.Title, {
          children: "Enter Custom Year"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("button", {
          type: "button",
          className: "btn-close",
          "aria-label": "Close",
          onClick: handleOthersModalClose,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("svg", {
            id: "Button_-_Close",
            "data-name": "Button - Close",
            xmlns: "http://www.w3.org/2000/svg",
            width: "44",
            height: "44",
            viewBox: "0 0 44 44",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("g", {
              id: "Ellipse_18",
              "data-name": "Ellipse 18",
              fill: "none",
              stroke: "#3c3c3b",
              strokeWidth: "1",
              opacity: "0.3",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("circle", {
                cx: "22",
                cy: "22",
                r: "22",
                stroke: "none"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("circle", {
                cx: "22",
                cy: "22",
                r: "21.5",
                fill: "none"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("g", {
              id: "Ellipse_19",
              "data-name": "Ellipse 19",
              fill: "none",
              stroke: "#3c3c3b",
              strokeWidth: "1",
              strokeDasharray: "0 142",
              opacity: '0',
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("circle", {
                cx: "22",
                cy: "22",
                r: "22",
                stroke: "none"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("circle", {
                cx: "22",
                cy: "22",
                r: "21.5",
                fill: "none"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("g", {
              id: "Group_18979",
              "data-name": "Group 18979",
              transform: "translate(-3149 -104.5)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("line", {
                id: "Line_4",
                "data-name": "Line 4",
                x2: "8",
                y2: "8",
                transform: "translate(3167 122.5)",
                fill: "none",
                stroke: "#3c3c3b",
                strokeLinecap: "round",
                strokeWidth: "1"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("line", {
                id: "Line_3877",
                "data-name": "Line 3877",
                x1: "8",
                y2: "8",
                transform: "translate(3167 122.5)",
                fill: "none",
                stroke: "#3c3c3b",
                strokeLinecap: "round",
                strokeWidth: "1"
              })]
            })]
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Body */ .Z.Body, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Group */ .Z.Group, {
          className: "modal-form-group",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Label */ .Z.Label, {
            children: "Enter a number between 1-15:"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Control */ .Z.Control, {
            className: "modal-form-control",
            type: "number",
            min: "1",
            max: "15",
            value: customYear,
            onChange: function onChange(e) {
              var value = e.target.value;
              setCustomYear(value); // Show error if value is greater than 15

              if (value && parseInt(value) > 15) {
                setModalYearError('Please enter a number between 1-15');
              } else {
                setModalYearError('');
              }
            },
            placeholder: "Enter year (1-15)"
          }), modalYearError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
            className: "modal-year-error",
            children: modalYearError
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Footer */ .Z.Footer, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
          className: "close-modal",
          onClick: handleOthersModalClose,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            variant: "secondary",
            text: "Cancel",
            hoverColor: "#6c757d",
            hoverBackground: "#6c757d"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
          className: "calculate-modal",
          onClick: handleOthersYearSubmit,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            variant: "primary",
            text: "Confirm",
            hoverColor: "#978C21",
            hoverBackground: "#978C21",
            disabled: !customYear || parseInt(customYear) < 1 || parseInt(customYear) > 15
          })
        })]
      })]
    })]
  });
};

InvestorCalculator.getInitialProps = _api_store__WEBPACK_IMPORTED_MODULE_10__/* .wrapper.getInitialPageProps */ .YS.getInitialPageProps(function (store) {
  return /*#__PURE__*/(0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5() {
    var _param;

    var api_services, param;
    return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            api_services = _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_8__/* .ApiServices.SECTIONS */ .u.SECTIONS;
            param = (_param = {}, (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.TYPE */ .j.TYPE, 'slug'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.VALUE */ .j.VALUE, 'investment-calculator'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.GET_SECTION */ .j.GET_SECTION, 'no'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.IMAGE */ .j.IMAGE, 'no'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.POST */ .j.POST, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.GALLERY */ .j.GALLERY, 'no'), _param);
            _context5.next = 4;
            return store.dispatch((0,_api_redux_investor__WEBPACK_IMPORTED_MODULE_11__/* .fetchPosts */ .T)([api_services, param]));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
});
var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_25__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "investment-calculator__StyledComponent",
  componentId: "sc-1fn5if9-0"
})([".chart-container{height:90vh;@media(max-width:767px){height:400px;}}.form-wrapper{position:relative;.calculator-error-message{position:absolute;bottom:0;}&.last{.calculator-error-message{bottom:10px;}.form-select{margin-bottom:40px;}}}.calculator-error-message{color:red;font-size:12px;}.desktop-view{display:flex;}.desktop-view-blog{display:block;}.mobile-view{display:none;}@media (max-width:767px){.desktop-view,.desktop-view-blog{flex-direction:column;.col-md-6{max-width:100%;width:100%;}}.mobile-view{display:block;}}.hints{font-size:14px !important;color:gray !important;margin-bottom:25px !important;margin-top:5px;font-weight:500;}.react-select__value-container{div:nth-of-type(5){svg{display:none;}}}.custom{border:1px solid black;border-collapse:collapse;td,th,td{border:1px solid black;}}.modal-data__content{border-top:none;}.dc-btn a:hover{span{color:white;}}.form{input[type=\"Date\"]{color:#3C3C3B;}.react-datepicker-wrapper{width:100%;}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before{left:-25px;}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after{left:-25px;}.react-datepicker__input-container{width:100%;input{width:100%;font-size:14px;font-weight:500;color:#3C3C3B;border-right:none;border-left:none;border-top:none;outline:none;box-shadow:none;padding-left:0;padding-right:0;padding-bottom:10px;padding-top:0;height:33px;margin-bottom:25px;border-bottom:1px solid rgba(60,60,59,0.5);&::placeholder{font-size:14px;font-weight:500;color:rgba(60,60,59,0.5);}}}.form-control{font-size:14px;font-weight:500;color:#3C3C3B;border-right:none;border-left:none;border-top:none;outline:none;box-shadow:none;padding-left:0;padding-right:0;padding-bottom:10px;padding-top:0;height:33px;margin-bottom:25px;border-bottom:1px solid rgba(60,60,59,0.5);&::placeholder{font-size:14px;font-weight:500;color:rgba(60,60,59,0.5);}}.react-select__indicator{padding:0;}.react-select__placeholder{margin:0;padding:0;font-size:14px;font-weight:500;color:rgba(60,60,59,0.5);}.react-select__control{border-bottom:1px solid rgba(60,60,59,0.5);margin-bottom:0px;border-right:none;border-left:none;border-top:none;outline:none;box-shadow:none;padding-left:0;padding-right:0;.react-select__indicator-separator{display:none;}.react-select__input-container{padding:0;margin:0;}.react-select__single-value{margin:0;padding:0;font-size:14px;font-weight:500;color:#3C3C3B;}.react-select__value-container{padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;}}}.result-wrp{p{color:rgba(60,60,59,0.5);margin-bottom:9px !important;&.last{margin-top:30px;}}h3{font-size:32px;font-weight:500;line-height:44px;color:#978C21;}.calculation-note{margin-top:20px !important;font-style:italic;small{color:rgba(60,60,59,0.7) !important;font-size:12px;}}&.error{p{color:#dc3545;font-weight:500;}}}.simplebar-content{&::-webkit-scrollbar{display:none;}}.invest-content{margin-top:80px;padding-top:80px;display:block;border-bottom:none !important;ul{margin:0;padding-left:0;border:none !important;li{font-size:16px;line-height:24px;font-weight:500;color:#3C3C3B;span{font-family:\"Avenir Heavy\";}p{font-size:20px;line-height:24px;font-weight:500;color:#3C3C3B;margin:0 !important;}padding:0px 0 20px 35px !important;z-index:50;position:relative;counter-increment:count;border-bottom:1px solid rgba(198,198,198,0.5);margin-bottom:20px !important;&:first-child{padding-top:0;}&:last-child{padding-bottom:0;border-bottom:0;margin-bottom:0 !important;}&:first-child:before{margin-top:0;}&:last-child:before{margin-bottom:0;}&:after{content:counter(count,upper-alpha) !important;position:absolute !important;;height:20px !important;;width:20px !important;;padding:1px 0px 0px 0px !important;;font-size:12px;line-height:20px;font-weight:500;border:1px solid #FFFFFF;background-color:#978C21;border-radius:50%;color:white !important;;top:0 !important;;left:0;display:flex;align-items:center;justify-content:center;}}}}@media (max-width:767px){.scroll-div{padding:0 !important;}.modal-data{margin-top:0 !important;}.modal-close{right:15px !important;}.result{margin-top:60px;}.invest-content{padding-top:60px;margin-bottom:60px;}.modal-data__content{margin-top:60px !important;padding:0 15px !important;}}.custom-modal-width{max-width:45% !important;@media (max-width:768px){max-width:90% !important;}}.modal{.modal-content{border-radius:8px;}.modal-header{border-bottom:1px solid #dee2e6;.modal-title{font-weight:600;color:#3C3C3B;}}.modal-body{padding:20px;.modal-form-group{margin-bottom:0;}.form-label{font-size:14px;font-weight:500;color:#3C3C3B;margin-bottom:15px;display:block;}.modal-form-control{font-size:14px;font-weight:500;color:#3C3C3B;border-right:none;border-left:none;border-top:none;outline:none;box-shadow:none;padding-left:0;padding-right:0;padding-bottom:10px;padding-top:0;height:33px;margin-bottom:25px;border-bottom:1px solid rgba(60,60,59,0.5);background:transparent;border-radius:0;width:100%;&::placeholder{font-size:14px;font-weight:500;color:rgba(60,60,59,0.5);}&:focus{border-bottom:1px solid #978C21;box-shadow:none;outline:none;}}.modal-year-error{color:red;font-size:12px;margin-top:5px;}}.modal-footer{border-top:1px solid #dee2e6;padding:15px 20px;.dc-btn{margin:0 5px;}}}"]);
/* harmony default export */ __webpack_exports__["default"] = (InvestorCalculator);

/***/ }),

/***/ 82458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Us": function() { return /* binding */ calculatePortfolioValue; },
/* harmony export */   "hA": function() { return /* binding */ calculatePortfolioValueFromAPI; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* unused harmony exports calculateCAGR, calculateCompoundInterest, calculateTotalReturn, processAPIResponse, calculateValueFromMultiplier, validateAPIResponse, extractLatestValue, calculatePortfolioWithHistoricalData, debugApiResponse, DEFAULT_STOCK_RETURNS */
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Investment Calculation Utilities - ENHANCED VERSION
 * Properly handles API response data from the backend investment calculator
 * Primary method: Uses historical daily returns with compound growth calculation
 * Fallback method: Uses default return rates if API data is unavailable
 */

/**
 * Calculate Compound Annual Growth Rate (CAGR)
 */
var calculateCAGR = function calculateCAGR(beginningValue, endingValue, numberOfYears) {
  if (beginningValue <= 0 || endingValue <= 0 || numberOfYears <= 0) {
    return 0;
  }

  return (Math.pow(endingValue / beginningValue, 1 / numberOfYears) - 1) * 100;
};
/**
 * Calculate compound interest - FALLBACK METHOD ONLY
 */

var calculateCompoundInterest = function calculateCompoundInterest(principal, rate, time) {
  var compoundingFrequency = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 12;

  if (principal <= 0 || rate < 0 || time <= 0) {
    return principal;
  }

  return principal * Math.pow(1 + rate / compoundingFrequency, compoundingFrequency * time);
};
/**
 * Calculate total return percentage
 */

var calculateTotalReturn = function calculateTotalReturn(initialValue, finalValue) {
  if (initialValue <= 0) {
    return 0;
  }

  return (finalValue - initialValue) / initialValue * 100;
};
/**
 * Process API response data - PRIMARY METHOD
 * Handles the structured response from the backend API
 */

var processAPIResponse = function processAPIResponse(apiData) {
  if (!apiData) {
    console.error('No API data provided');
    return null;
  } // Check for error status in API response


  if (apiData.status && apiData.status !== 200) {
    console.error('API returned error:', apiData.message);
    return null;
  } // Handle different response formats


  var summary, portfolioValue, dailyReturns, cumulativeReturns;

  if (apiData.summary) {
    // Direct format
    summary = apiData.summary;
    portfolioValue = apiData.portfolioValue || [];
    dailyReturns = apiData.dailyreturn || [];
    cumulativeReturns = apiData.cumulative || [];
  } else if (apiData.data && apiData.data.summary) {
    // Nested format
    summary = apiData.data.summary;
    portfolioValue = apiData.data.portfolioValue || [];
    dailyReturns = apiData.data.dailyreturn || [];
    cumulativeReturns = apiData.data.cumulative || [];
  } else {
    console.error('Invalid API response format:', apiData);
    return null;
  }

  if (!summary) {
    console.error('No summary data found in API response');
    return null;
  }

  return {
    initialInvestment: summary.initial_investment || 0,
    finalValue: summary.final_value || 0,
    totalReturn: summary.total_return_pct || 0,
    cagr: summary.cagr_pct || 0,
    volatility: summary.volatility_pct || 0,
    sharpeRatio: summary.sharpe_ratio || 0,
    investmentPeriod: summary.investment_period_years || 0,
    numberOfStocks: summary.number_of_stocks || 0,
    cumulativeMultiplier: summary.cumulative_multiplier || 1,
    portfolioData: portfolioValue,
    dailyReturns: dailyReturns,
    cumulativeReturns: cumulativeReturns,
    totalRecordsProcessed: summary.total_records_processed || portfolioValue.length,
    calculationMethod: 'historical_compound_returns'
  };
};
/**
 * Calculate portfolio value from cumulative multiplier - PREFERRED METHOD
 * This is the most accurate method using the API's compound calculation
 */

var calculateValueFromMultiplier = function calculateValueFromMultiplier(initialInvestment, cumulativeMultiplier) {
  if (!cumulativeMultiplier || cumulativeMultiplier <= 0) {
    console.warn('Invalid cumulative multiplier, using original investment amount');
    return initialInvestment;
  }

  return initialInvestment * cumulativeMultiplier;
};
/**
 * Validate API response
 */

var validateAPIResponse = function validateAPIResponse(apiData) {
  if (!apiData) {
    return {
      isValid: false,
      error: 'No API response data'
    };
  }

  if (apiData.status && apiData.status !== 200) {
    return {
      isValid: false,
      error: apiData.message || 'API returned error status'
    };
  }

  var processed = processAPIResponse(apiData);

  if (!processed) {
    return {
      isValid: false,
      error: 'Failed to process API response'
    };
  }

  return {
    isValid: true,
    data: processed
  };
};
/**
 * Extract latest value from mixed API response
 */

var extractLatestValue = function extractLatestValue(source) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['value'];
  if (source == null) return 0;
  var items = Array.isArray(source) ? source : [source];
  var last = items[items.length - 1];
  if (typeof last === 'number') return last;

  if (typeof last === 'object') {
    var _iterator = _createForOfIteratorHelper(keys),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var val = last[key];
        if (typeof val === 'number') return val;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return 0;
};
/**
 * Calculate portfolio value using API return data with compound formula
 * FIXED: Better handling of API data and more robust calculations
 */

var calculatePortfolioValueFromAPI = function calculatePortfolioValueFromAPI(initialInvestment, apiPortfolioData, years) {
  if (!Array.isArray(apiPortfolioData) || apiPortfolioData.length === 0 || initialInvestment <= 0 || years <= 0) {
    return {
      finalValue: initialInvestment,
      totalReturn: 0,
      cagr: 0,
      yearlyData: []
    };
  }

  var yearlyData = [];
  var currentPortfolioValue = initialInvestment; // Filter out invalid data points

  var validDataPoints = apiPortfolioData.filter(function (dataPoint) {
    return dataPoint && (dataPoint.result !== undefined || dataPoint.value !== undefined);
  });

  if (validDataPoints.length === 0) {
    return {
      finalValue: initialInvestment,
      totalReturn: 0,
      cagr: 0,
      yearlyData: []
    };
  }

  validDataPoints.forEach(function (dataPoint, index) {
    // Extract return value - try multiple possible keys
    var returnValue = dataPoint.result || dataPoint.value || dataPoint["return"] || 0; // Convert string to number if needed

    if (typeof returnValue === 'string') {
      returnValue = parseFloat(returnValue) || 0;
    } // Handle different return formats
    // If return value is greater than 1, assume it's already a multiplier
    // If return value is between 0 and 1, assume it's a decimal return rate
    // If return value is greater than 1 but less than 10, assume it's a percentage that needs conversion


    var factor;

    if (returnValue > 10) {
      // Likely a percentage like 15.5 (meaning 15.5%)
      factor = 1 + returnValue / 100;
    } else if (returnValue > 1) {
      // Likely already a multiplier like 1.155
      factor = returnValue;
    } else if (returnValue >= 0 && returnValue <= 1) {
      // Decimal return like 0.155
      factor = 1 + returnValue;
    } else {
      // Negative or invalid value
      factor = 1;
    }

    currentPortfolioValue *= factor;
    yearlyData.push({
      year: index + 1,
      value: currentPortfolioValue,
      totalReturn: calculateTotalReturn(initialInvestment, currentPortfolioValue),
      returnFactor: factor,
      apiResult: returnValue,
      originalApiData: dataPoint
    });
  });
  var finalValue = yearlyData.length > 0 ? yearlyData[yearlyData.length - 1].value : initialInvestment;
  var totalReturn = calculateTotalReturn(initialInvestment, finalValue);
  var cagr = calculateCAGR(initialInvestment, finalValue, years);
  return {
    finalValue: finalValue,
    totalReturn: totalReturn,
    cagr: cagr,
    yearlyData: yearlyData
  };
};
/**
 * Fallback calculation using default returns
 * ENHANCED: Better error handling and logging
 */

var calculatePortfolioValue = function calculatePortfolioValue(initialInvestment, selectedStocks, years) {
  if (!Array.isArray(selectedStocks) || selectedStocks.length === 0 || initialInvestment <= 0 || years <= 0) {
    return {
      finalValue: initialInvestment,
      totalReturn: 0,
      cagr: 0,
      yearlyData: []
    };
  }

  var stockReturns = selectedStocks.map(function (stock) {
    var returnRate = DEFAULT_STOCK_RETURNS[stock] || 0.10;
    return returnRate;
  });
  var averageReturn = stockReturns.reduce(function (sum, r) {
    return sum + r;
  }, 0) / stockReturns.length;
  var currentPortfolioValue = initialInvestment;
  var yearlyData = [];

  for (var year = 1; year <= years; year++) {
    var factor = 1 + averageReturn;
    currentPortfolioValue *= factor;
    yearlyData.push({
      year: year,
      value: currentPortfolioValue,
      totalReturn: calculateTotalReturn(initialInvestment, currentPortfolioValue),
      returnFactor: factor,
      annualReturn: averageReturn
    });
  }

  var finalValue = currentPortfolioValue;
  var totalReturn = calculateTotalReturn(initialInvestment, finalValue);
  var cagr = calculateCAGR(initialInvestment, finalValue, years);
  return {
    finalValue: finalValue,
    totalReturn: totalReturn,
    cagr: cagr,
    yearlyData: yearlyData
  };
};
/**
 * Calculate portfolio value with historical stock data
 */

var calculatePortfolioWithHistoricalData = function calculatePortfolioWithHistoricalData(initialInvestment, historicalData, years) {
  var _firstDay$stocks;

  if (!Array.isArray(historicalData) || historicalData.length === 0) {
    return {
      finalValue: initialInvestment,
      totalReturn: 0,
      cagr: 0,
      monthlyData: []
    };
  }

  var endDate = new Date();
  var startDate = new Date();
  startDate.setFullYear(endDate.getFullYear() - years);
  var filteredData = historicalData.filter(function (data) {
    var dataDate = new Date(data.date);
    return dataDate >= startDate && dataDate <= endDate;
  });

  if (filteredData.length === 0) {
    return {
      finalValue: initialInvestment,
      totalReturn: 0,
      cagr: 0,
      monthlyData: []
    };
  }

  filteredData.sort(function (a, b) {
    return new Date(a.date) - new Date(b.date);
  });
  var firstDay = filteredData[0];
  var stockSymbols = ((_firstDay$stocks = firstDay.stocks) === null || _firstDay$stocks === void 0 ? void 0 : _firstDay$stocks.map(function (stock) {
    return stock.symbol;
  })) || [];
  var investmentPerStock = initialInvestment / stockSymbols.length;
  var initialPrices = {};
  stockSymbols.forEach(function (symbol) {
    var stock = firstDay.stocks.find(function (s) {
      return s.symbol === symbol;
    });

    if (stock) {
      initialPrices[symbol] = stock.price;
    }
  });
  var monthlyData = [];
  filteredData.forEach(function (dataPoint) {
    if (Array.isArray(dataPoint.stocks)) {
      var portfolioValue = 0;
      dataPoint.stocks.forEach(function (stock) {
        var initialPrice = initialPrices[stock.symbol];
        if (!initialPrice || initialPrice === 0) return;
        var currentPrice = stock.price;
        var priceMultiplier = currentPrice / initialPrice;
        portfolioValue += investmentPerStock * priceMultiplier;
      });
      monthlyData.push({
        date: dataPoint.date,
        value: portfolioValue,
        totalReturn: calculateTotalReturn(initialInvestment, portfolioValue)
      });
    }
  });
  var finalValue = monthlyData.length > 0 ? monthlyData[monthlyData.length - 1].value : initialInvestment;
  var totalReturn = calculateTotalReturn(initialInvestment, finalValue);
  var cagr = calculateCAGR(initialInvestment, finalValue, years);
  return {
    finalValue: finalValue,
    totalReturn: totalReturn,
    cagr: cagr,
    monthlyData: monthlyData
  };
};
/**
 * ENHANCED: Better number formatting with proper validation
 */

var formatCurrency = function formatCurrency(value) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BDT';
  var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  // Handle null, undefined, or NaN values
  if (value == null || isNaN(value)) {
    return "".concat(currency, " 0.00");
  } // Convert to number if it's a string


  var numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) {
    return "".concat(currency, " 0.00");
  }

  return "".concat(currency, " ").concat(numValue.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }));
};
/**
 * ENHANCED: Better percentage formatting with proper validation
 */

var formatPercentage = function formatPercentage(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  // Handle null, undefined, or NaN values
  if (value == null || isNaN(value)) {
    return '0.00%';
  } // Convert to number if it's a string


  var numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) {
    return '0.00%';
  }

  return "".concat(numValue.toFixed(decimals), "%");
};
/**
 * ENHANCED: Add debugging helper function
 */

var debugApiResponse = function debugApiResponse(apiData) {
  if (apiData.portfolioValue) {}

  if (apiData.totalreturn) {}

  if (apiData.csgr) {}
};
/**
 * Default stock return rates
 * ENHANCED: Added more realistic return rates and better documentation
 */

var DEFAULT_STOCK_RETURNS = {
  'BRACBANK': 0.12,
  // 12% annual return
  'CITYBANK': 0.10,
  // 10% annual return
  'SQURPHARMA': 0.15,
  // 15% annual return
  'RENATA': 0.14,
  // 14% annual return
  'BXPHARMA': 0.13,
  // 13% annual return
  'MARICO': 0.11,
  // 11% annual return
  'RECKITTBEN': 0.09,
  // 9% annual return
  'OLYMPIC': 0.08,
  // 8% annual return
  'BATBC': 0.10,
  // 10% annual return
  'LHBL': 0.12,
  // 12% annual return
  'UNILEVERCL': 0.11,
  // 11% annual return
  'HEIDELBCEM': 0.07,
  // 7% annual return
  'LINDEBD': 0.09,
  // 9% annual return
  'BERGERPBL': 0.13,
  // 13% annual return
  'GP': 0.14,
  // 14% annual return
  'UPGDCL': 0.16 // 16% annual return

};

/***/ }),

/***/ 3179:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investment-calculator",
      function () {
        return __webpack_require__(93365);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18698:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 35752:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICA8ZyBpZD0iR3JvdXBfMTg5OTkiIGRhdGEtbmFtZT0iR3JvdXAgMTg5OTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02NDUuNSAtNjg4NC41KSI+CiAgICA8bGluZSBpZD0iTGluZV8xMjM3MiIgZGF0YS1uYW1lPSJMaW5lIDEyMzcyIiB5Mj0iMTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY1MS41IDY4ODUuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzk3OEMyMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzEyMzczIiBkYXRhLW5hbWU9IkxpbmUgMTIzNzMiIHkyPSIxMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjU2LjUgNjg5MC41KSByb3RhdGUoOTApIiBmaWxsPSJub25lIiBzdHJva2U9IiM5NzhDMjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8698,4885,7118,696,9774,2888,179], function() { return __webpack_exec__(3179); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);